<template>
  <div>
    <search-bar :hasTitle="true" :backgroundColorGray="true" :showVideo="true"></search-bar>

    <carousel :data="bannersForslides"></carousel>

    <section>
      <div class="container">
        <div class="clearfix">
          <h2 class="text-center">Últimos lançamentos</h2>
        </div>
      </div>

      <div class="w-100 d-inline-flex justify-content-center">
        <div class="item m-5" v-for="item in releases" style="cursor: pointer;">
          <a
            :href="'https://static.japanparts.com.br' + item.launch_image"
            target="_blank"
          >
            <img :src="url + item.launch_image" alt>
          </a>
        </div>
      </div>


      <div class="mt-3 container" style="cursor: pointer;">
        <div class="d-flex justify-content-center">
          <router-link to="/lancamentos">
            <a href="#" class="btn btn-lg btn-primary">Ver Todos</a>
          </router-link>
        </div>
      </div>
    </section>

    <div class="diagonal-line diagonal-gray"></div>
    <section class="section-gray section-filters">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="phones">
              <img src="../../static/images/phones.png" alt>
            </div>
          </div>
          <div class="col-md-6 offset-md-2 text-center text-md-left">
            <h1 class="brand-secondary">Busque os seus filtros com mais facilidade.</h1>
            <div>Com o nosso aplicativo, você consegue encontrar os seus filtros em qualquer hora, e em qualquer lugar.</div>
            <div class="row mt-5">
              <div class="col-sm-4 offset-sm-2 col-6">
                <a href="https://play.google.com/store/apps/details?id=br.com.fastlube">
                  <img src="../../static/images/play.png" alt>
                </a>
              </div>
              <div class="col-sm-4 col-6">
                <a
                  href="https://itunes.apple.com/br/app/cat%C3%A1logo-japanparts/id1445098753?mt=8"
                >
                  <img src="../../static/images/ios.png" alt>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section>
      <div class="container">
        <div class="clearfix">
          <h2 class="brand-primary float-md-left text-center text-md-left">Vídeos Técnicos</h2>
          <!--<div class="float-right d-none d-md-block">
            <a href="#">+ Ver Todos</a>
          </div>-->
        </div>
      </div>

      <div class="slide-videos">
        <div class="container">
          <div class="slide-items js-videos">
            <!-- <div class="item" v-for="video in videosForslides" :key="video.id">
              <div class="title">{{video.title}}</div>
              <div class="video">
                 <youtube :video-id="getId(video.embed_link)" :player-vars="playerVars" @playing="playing"></youtube>

              </div>
            </div>-->

            <div class="item" v-for="video in videosForslides" :key="video.id">
              <div class="title">{{video.title}}</div>
              <div class="video">
                <div class="youtube" :data-embed="video.embed">
                  <div class="play-button"></div>
                </div>
              </div>
            </div>

            <!-- <div class="item" v-for="video in videosForslides" :key="video.id">
              <div class="title">{{video.title}}</div>
              <div class="video">
                <iframe
                  :src="`${video.embed_link}`"
                  frameborder="0"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
              </div>
            </div>-->

            <!-- <div class="item">
              <div class="title">Filtro de Óleo Refil FO007S FIAT MOTOR E-TORQ - Troca</div>
              <div class="video">
                <iframe
                  src="https://www.youtube.com/embed/9EzwidkxnWo?controls=0"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>-->
          </div>
        </div>
      </div>

      <div class="d-md-none text-center">
        <a href="#">+ Ver Todos</a>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <h1 class="brand-primary text-center text-lg-left">
              Newsletter
              <span
                class="brand-secondary ml-lg-5 mt-3 d-block d-lg-inline-block"
              >Cadastre-se para receber nossos Lançamentos</span>
            </h1>
            <div class="search-bar">
              <input
                type="text"
                class="form-control"
                placeholder="Escreva seu email e receba nossas novidades!"
                v-validate="'required|email'"
                v-model="newsletter.email"
              >
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="registerNewsletter"
              >Enviar</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="diagonal-line"></div>

    <template id="modal-template" v-if="showModal" @close="showModal = false">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-body">
                <slot name="body">
                  <span @click="showModal = false" class="close-modal">x</span>
                  <a href="https://japanparts.com.br/lancamentos" target="_blank"><img src="/static/images/popup-home.jpg"></a>
                </slot>
              </div>

            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>


<script>
import swal from "sweetalert2";
import BackToTop from "vue-backtotop";
import axios from "axios";

import BannerAPI from "@/api/banner";
import VideoAPI from "@/api/video";
import PartAPI from "@/api/part";
import VehicleAPI from "@/api/vehicle.vue";
import NewsletterAPI from "@/api/newsletter.vue";
import ReleaseAPI from "@/api/release";

import SearchBar from "@/components/SearchBar.vue";
import SweetAlert from "@/components/EspressoAux.vue";

let VueScrollTo = require("vue-scrollto");

export default {
  name: "Home",
  data() {
    return {
      url: "https://static.japanparts.com.br",
      searchData: "",
      slides: [],
      bannersForslides: [],
      videosForslides: [],
      features: [],
      subCategories: [],
      manufacturers: [],
      categories: [],
      vehicleModels: [],
      newsletter: {
        email: ""
      },
      playerVars: {
        autoplay: 0
      },
      releases: [],
      showModal: false
    };
  },
  components: {
    SearchBar,
    modal: {
      template: "#modal-template"
    }
  },

  async mounted() {
    await this.loadAllInfo();
  },

  methods: {
    async loadAllInfo() {
      await Promise.all([
        this.loadVideos(),
        this.loadBanners(),
        this.loadReleases()
        // this.loadFeatures(),
        // this.loadManufactures(),
        // this.loadCategories(),
        // this.loadSubcategories(),
        // this.loadVehicleModels()
      ]);
      this.loadScript();
      this.allowPLay();
    },
    loadScript() {
      let ckeditor = document.createElement("script");
      ckeditor.setAttribute("src", "../../static/js/script.js");
      document.head.appendChild(ckeditor);
    },
    async loadBanners() {
      this.slides = await BannerAPI.get();
      this.slides.forEach(bannerLink => {
        this.bannersForslides.push(
          ![null, undefined, ""].includes(bannerLink.link)
            ? `<router-link class="item" to="${
                bannerLink.link
              }"><img class="banner-item" src="${this.slides.urlImages}${
                bannerLink.thumb
              }" alt />
          </router-link>`
            : `<div class="item"><img class="banner-item" src="${
                this.slides.urlImages
              }${bannerLink.thumb}" alt></div>`
        );
      });
    },
    async loadVideos() {
      this.videosForslides = await VideoAPI.get();
      this.videosForslides.forEach(video => {
        video.embed = video.embed_link.split("/")[4];
      });
      this.allowPLay();
    },
    async loadVehicleModels() {
      this.vehicleModels = await VehicleAPI.getModels();
    },
    async loadFeatures() {
      this.features = await PartAPI.getFeatureHome();
    },
    async loadSubcategories() {
      this.subCategories = await PartAPI.getSubCategories();
    },
    async loadCategories() {
      this.categories = await PartAPI.getCategories();
    },
    async loadManufactures() {
      let partManufactures = await PartAPI.getManufacturers();
      let vehicleManufactures = await VehicleAPI.getManufacturers();
      this.manufacturers = [...partManufactures, vehicleManufactures];
      this.manufacturers.sort((a, b) => {
        return ("" + a.name).localeCompare(b.name);
      });
    },
    async loadReleases() {
      this.releases = await ReleaseAPI.getLatestReleases(4);
    },
    async registerNewsletter() {
      const isValid = await this.$validator.validate();
      if (isValid) {
        const response = await NewsletterAPI.register(this.newsletter);
        if (response.success) {
          SweetAlert.showSuccessModal("Informações enviadas com sucesso!");
        } else {
          SweetAlert.showFailModal("Por favor, tente novamente mais tarde!");
        }
      } else {
        SweetAlert.showFailModal("Preencha o e-mail corretamente!");
      }
    },
    allowPLay() {
      var youtube = document.querySelectorAll(".youtube");
      console.log(youtube[0]);

      for (var i = 0; i < youtube.length; i++) {
        var source =
          "https://img.youtube.com/vi/" +
          youtube[i].dataset.embed +
          "/sddefault.jpg";

        var image = new Image();
        image.src = source;
        image.addEventListener(
          "load",
          (function() {
            youtube[i].appendChild(image);
          })(i)
        );

        youtube[i].addEventListener("click", function() {
          var iframe = document.createElement("iframe");
          //console.log("clicou", this);

          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "allowfullscreen");
          // iframe.setAttribute("allow", "accelerometer");
          // iframe.setAttribute("allow", "autoplay");
          // iframe.setAttribute("allow", "encrypted-media");
          // iframe.setAttribute("allow", "gyroscope");
          // iframe.setAttribute("allow", "picture-in-picture");

          iframe.setAttribute(
            "src",
            "https://www.youtube.com/embed/" +
              this.dataset.embed +
              "?rel=0&showinfo=0&autoplay=1"
          );

          this.innerHTML = "";
          this.appendChild(iframe);
        });
      }
    }
  }
};
</script>



<style scoped>
.youtube {
  background-color: #000;

  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.youtube .play-button {
  width: 90px;
  height: 60px;
  background-color: #333;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.6);
  z-index: 1;
  opacity: 0.8;
  border-radius: 6px;
}
.youtube .play-button:before {
  content: "";
  border-style: solid;
  border-width: 15px 0 15px 26px;
  border-color: transparent transparent transparent #fff;
}
.youtube img,
.youtube .play-button {
  cursor: pointer;
}
.youtube img,
.youtube iframe,
.youtube .play-button,
.youtube .play-button:before {
  position: absolute;
}
.youtube .play-button,
.youtube .play-button:before {
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}
.youtube iframe {
  height: 100%;
  width: 100%;
  top: 0;
}
</style>

<style>
.youtube {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 185px;
}

@media (max-width: 900px) {
  .youtube {
    height: 140px;
  }
}
.youtube iframe {
  position: relative;
  /* height: 185px;
  width: 310px; */
}

.category-box {
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  flex-direction: column;
}

.d-inline-flex {
  padding-left: 10%;
  padding-right: 10%;
}

.d-inline-flex .item img {
  max-height: 300px;
  min-width: 100px;
}

.category-box img {
  /* height: 185px;
  width: 310px; */
}

.banner-item {
  object-fit: contain;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  max-width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0 0 20px;
  padding-top: 0;
}

.modal-default-button {
  float: right;
}

.close-modal {
  font-size: 2rem;
  float: right;
  cursor: pointer;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue